import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=03c73306&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"
import style0 from "./DictItemList.vue?vue&type=style&index=0&id=03c73306&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c73306",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c73306')) {
      api.createRecord('03c73306', component.options)
    } else {
      api.reload('03c73306', component.options)
    }
    module.hot.accept("./DictItemList.vue?vue&type=template&id=03c73306&scoped=true&", function () {
      api.rerender('03c73306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictItemList.vue"
export default component.exports